import { render } from "./DecisionPositionsGrid.vue?vue&type=template&id=12f1b2f6&scoped=true"
import script from "./DecisionPositionsGrid.vue?vue&type=script&lang=js"
export * from "./DecisionPositionsGrid.vue?vue&type=script&lang=js"

import "./DecisionPositionsGrid.vue?vue&type=style&index=0&id=12f1b2f6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f1b2f6"]])

export default __exports__